import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: IAppState = {
  headerConfig: {
    title: '',
    subtitle: '',
    hasBackArrow: false,
    backArrowTo: null,
    helmetTitle: ''
  }
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setHeaderConfig: (
      state,
      action: PayloadAction<Partial<IAppState['headerConfig']>>
    ) => {
      state.headerConfig = {
        ...initialState.headerConfig,
        ...action.payload
      };
    }
  }
});

export const { setHeaderConfig } = appSlice.actions;
export default appSlice;

interface IAppState {
  headerConfig: {
    title: string;
    subtitle: string;
    hasBackArrow: boolean;
    backArrowTo: string | -1 | null;
    helmetTitle: string;
  };
}
